import { translate } from '@gig/magic-common';
import { __awaiter, __generator } from 'tslib';
import { getPasswordMaxLength, getUnmaskPasswordFeature } from '@gig/magic-jurisdictions/dist/sign-up-form-config';
import { username } from './username-config.js';
import { password } from './password-config.js';

function getLoginFormConfig(errorMessage, messageType) {
    return __awaiter(this, void 0, void 0, function () {
        var unmaskPassword, passwordMinLength;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getUnmaskPasswordFeature()];
                case 1:
                    unmaskPassword = _a.sent();
                    return [4 /*yield*/, getPasswordMaxLength()];
                case 2:
                    passwordMinLength = _a.sent();
                    return [2 /*return*/, [
                            {
                                name: 'step-1',
                                path: 'step-1',
                                components: [
                                    username(),
                                    password({
                                        passwordMinLength: passwordMinLength,
                                        unmaskPassword: unmaskPassword,
                                    }),
                                ],
                                nextButton: {
                                    text: translate('login.button'),
                                    alwaysEnabled: true,
                                },
                                errorMessage: errorMessage,
                                alwaysShowErrorMessage: messageType === 'error',
                            },
                        ]];
            }
        });
    });
}

export { getLoginFormConfig };
